<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="5">
        <el-card class="box-card">

          <el-input type="textarea" v-model="videoLinksInput"
                    :rows="30"
                    placeholder="请输入链接,多个链接请换行"
          ></el-input>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-button icon="el-icon-search" @click="generateLinks" >解析</el-button>
        <el-divider></el-divider>
        <el-table  :data="generatedLinksInfo" stripe>
          <el-table-column prop="palybackUrl" label="直播回放URL"></el-table-column>
          <el-table-column prop="liveCover" label="直播封面"></el-table-column>
          <el-table-column prop="liveTitle" label="直播标题"></el-table-column>
          <el-table-column prop="liveStartTime" label="直播开始时间"></el-table-column>
          <el-table-column prop="playbackLikeCount" label="回放点赞数"></el-table-column>
          <el-table-column prop="playbackViewCount" label="回放观看数"></el-table-column>
          <el-table-column prop="livePlayUrl" label="回放视频播放地址"></el-table-column>
          <el-table-column prop="userProfile" label="作者主页"></el-table-column>
          <el-table-column prop="username" label="房主昵称"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}
</style>
<script>
import axios from 'axios'
// import dayjs from "dayjs";




export default {
  name: "dyshortlink",
  data() {
    return {
      goodsId: '',
      videoLinks: [],
      videoLinksInput:'',
      generatedLinksInfo: [],
      douyinCode:'',
      originUrl:''
    };
  },
  methods: {
    generateLinks(){
      const _self = this;
      if(this.videoLinksInput === '') {
        alert('请输入视频短链接.')
        return;
      }

      this.videoLinks = this.videoLinksInput.split('\n')
      if(this.videoLinksInput.length === 0) {
        alert('请输入视频短链接.')
        return;
      } else {
        _self.processLink();
      }

    },
    processLink() {
      const _self = this;
      if(this.videoLinks.length > 0) {
        const videoLink = this.videoLinks.shift();
        axios.get("/tp_api_712/ksLivePlaybackv1?api_key=8sArXN5ippGEAVAH89nw&url=" + videoLink)
            .then((content) => {
              console.log(content)
              if (content && content.data.palybackUrl) {
                _self.generatedLinksInfo.push(content.data);


              }
              setTimeout(_self.processLink,150)


            });
      } else {
        alert('无待处理的商品链接');
      }
    },
  },
  mounted() {
  },
};
</script>
